import { render, staticRenderFns } from "./Net_Salary.vue?vue&type=template&id=80dc0c5a&scoped=true&"
import script from "./Net_Salary.vue?vue&type=script&lang=js&"
export * from "./Net_Salary.vue?vue&type=script&lang=js&"
import style0 from "./Net_Salary.vue?vue&type=style&index=0&id=80dc0c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80dc0c5a",
  null
  
)

export default component.exports